<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-08-16 10:27:09
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-16 11:06:15
-->
<template>
    <div>
         <div class="search">
            <div style="display:flex">
                <div  @click="openRules"  class="btn-two">监测规则</div>
            </div>
             <div>
                <a-range-picker style="margin-right:12px" v-model="time" format="YYYY-MM-DD HH:mm:ss"/>
                <el-button @click="search" type="primary">查询</el-button>
            </div>
            </div>
            <div class="table-box">
                <coententTable
              :y="height"
              @onShowSizeChange="onShowSizeChange"
              :columns="columns"
              :pagination="pagination"
              :dataSource="dataSource"
              :bordered='true'
              :loading="loading"
              :customSlot="customSlot"
              @handleSizeChange="handleSizeChange"
            >
              <template v-slot:operation="scopeVal">
                  <div v-if="siteId != 1" style="display:flex">
                     <div style="margin-right:12px" v-if="codeData.indexOf('432') != -1" @click="openList(scopeVal.scope,1)" class="btnTwo">下载乡镇清单</div>
                     <div  v-if="codeData.indexOf('432') != -1" @click="openList(scopeVal.scope,0)" class="btnTwo">下载部门清单</div>
                  </div>
                   <div v-if="siteId == 1" style="display:flex">
                     <div  v-if="codeData.indexOf('432') != -1" @click="openList(scopeVal.scope,0)" style="width:190px" class="btnTwo">下载州级部门（信息公开）清单</div>
                  </div>
              </template>
            </coententTable>
            </div>
            <DetectionRules v-if="dialogVisible" @handleClose="handleClose" :dialogVisible="dialogVisible"></DetectionRules>
    </div>
</template>
<script>
import {moreList,exportMoreList} from '../index';
import coententTable from "@/components/coentent_table.vue";
import DetectionRules from "./detection_rules.vue";
export default {
  components: {coententTable,DetectionRules},
  data() {
    return {
      height: 0,
      loading: false,
      columns: [],
      customSlot: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
      },
      dataSource: [],
      time: [],
      dialogVisible:false,
      itemData:{},
      codeData:[],
      siteId:'',
    };
  },

  mounted() {
    this.getList()
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    this.siteId = sessionStorage.getItem('siteId');
    if( this.siteId == 1){
        this.columns = [
          
        {
          title: "监测日期",
          dataIndex: "time",
          width: 200,
          ellipsis: true,
        },
        {
          title: "州级部门（信息公开）",
          dataIndex: "columnNumber",
          width: 200,
          ellipsis: true,
          children: [
                {
                    title: '不更新栏目数',
                    dataIndex: 'deptNotUpdateNum',
                    width: 150,
                   
                },
                 {
                    title: '空栏目数',
                    dataIndex: 'deptNullColNum',
                    width: 150,
                },
                 

           ]
        },
        {
          title: "监测站点",
          dataIndex: "siteName",
          ellipsis: true,
          customCell: (column) => {
            return {
              style: {
                "min-width": "120px",
                "max-width": "400px",
              },
            };
          },
          customHeaderCell: (column) => {
            return {
              style: {
                "min-width": "120px",
                "max-width": "400px",
              },
            };
          },
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 260,
          fixed: "right",
        },
      
        ]
    }else{
       this.columns = [
          
        {
          title: "监测日期",
          dataIndex: "time",
          width: 200,
          ellipsis: true,
        },
        {
          title: "部门",
          dataIndex: "columnNumber",
          width: 200,
          ellipsis: true,
          children: [
                {
                    title: '不更新栏目数',
                    dataIndex: 'deptNotUpdateNum',
                    width: 150,
                   
                },
                 {
                    title: '空栏目数',
                    dataIndex: 'deptNullColNum',
                    width: 150,
                },
                 

           ]
        },
        {
          title: "乡镇",
          dataIndex: "columnNumber",
          width: 200,
          ellipsis: true,
          children: [
                {
                    title: '不更新栏目数',
                    dataIndex: 'villageNotUpdateNum',
                    width: 150,
                   
                },
                 {
                    title: '空栏目数',
                    dataIndex: 'villageNullColNum',
                    width: 150,
                },
                 

           ]
        },
        {
          title: "监测站点",
          dataIndex: "siteName",
          ellipsis: true,
          customCell: (column) => {
            return {
              style: {
                "min-width": "120px",
                "max-width": "400px",
              },
            };
          },
          customHeaderCell: (column) => {
            return {
              style: {
                "min-width": "120px",
                "max-width": "400px",
              },
            };
          },
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 260,
          fixed: "right",
        },
      
        ]
    }
  },
  methods: {
    
    farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      (":");
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD;
    },
    getList() {
      this.loading = true;
      let startTime = '';
      let endTime = '';
      if(this.time.length > 0){
        startTime  = this.farmatDate(new Date(this.time[0].toString()).getTime(),'-')
        endTime = this.farmatDate(new Date(this.time[1].toString()).getTime(),'-')
      }
      moreList({
        current:this.pagination.current,
        size:this.pagination.pageSize,
        endTime:endTime,
        startTime:startTime,
        siteId:sessionStorage.getItem('siteId')
      }).then((res)=>{
              if(res.code == 0){
              this.dataSource = res.data.records;
              this.pagination.current =  res.data.current;
              this.pagination.total =  res.data.total;
              if(this.pagination.total > 0){
                this.height = document.documentElement.clientHeight - 419;
                window.onresize = () => {
                    return (() => {
                      this.height = document.documentElement.clientHeight - 419;
                    })();
                  };
              }
              this.loading = false;
          }else{
            this.loading = false;
          }
      })
    },
    search() {
       this.pagination.current = 1;
       this.getList();
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getList();
    },
    openList(item,type){
       let fileName = '';
       if( this.siteId == 1){
            fileName = `州级部门（信息公开）栏目监测表（${item.time}）`
       }else{
        if(type == 0){
            fileName = `${sessionStorage.getItem('siteName')}（部门）栏目监测表（${item.time}）`
        }else{
            fileName = `${sessionStorage.getItem('siteName')}（乡镇）栏目监测表（${item.time}）`
        }
          
       }
         exportMoreList({
            time:item.time,
            type,
            siteId: this.siteId,
            fileName,
         }).then((res)=>{

         })   
    },
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.current = 1;
      this.getList();
    },
    openRules(){
      this.dialogVisible = true;
    },
    handleClose(){
        this.dialogVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.search {
  padding: 0 24px 0 24px;
  justify-content: space-between;
  display: flex;
  margin-top: 20px;
  /deep/ .ant-select-selection {
    background-color: rgba(245, 247, 250, 1);
    height: 40px;
  }
  /deep/ .ant-input {
    background-color: rgba(245, 247, 250, 1);
    height: 40px;
  }
  /deep/ .el-input__inner {
    background-color: rgba(245, 247, 250, 1);
    height: 40px;
  }
  /deep/ input::-webkit-input-placeholder {
    color: rgba(102, 111, 128, 1);
  }
  /deep/ .ant-select-selection__placeholder {
    color: rgba(102, 111, 128, 1);
  }
  /deep/ .ant-select-selection__rendered {
    line-height: 39px;
  }
  /deep/ .el-select__tags {
    white-space: nowrap;
    overflow: hidden;
  }
  /deep/ .el-select__tags {
    flex-wrap: nowrap;
  }
}
/deep/ .el-tabs__header{
  margin: 0px;
}
.el-button--primary {
  background: #176de6;
}

.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 90px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.status-txt-one{
  color: rgba(103, 194, 58, 1);
  font-size: 14px;
  text-align: left;
  font-family: Microsoft Yahei;
}
.status-txt-two{
  color: rgba(245, 108, 108, 1);
  font-size: 14px;
  font-family: Microsoft Yahei;
}
.btn-two{
  width: 96px;
  height: 40px;
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  text-align: center;
  border: 1px solid rgba(23, 109, 230, 1);
  display: flex;
  align-items: center;
  justify-content:center;
  color: rgba(23, 109, 230, 1);
  cursor: pointer;
}
.status-txt-three{
  background-color: rgba(255, 255, 255, 1);
  color: rgba(230, 162, 60, 1);
  font-size: 14px;
  text-align: left;
  font-family: Microsoft Yahei;
}
.table-box{
  /deep/ .ant-table-fixed{
    border: none;
    
  }
  /deep/ .ant-table-fixed-right .ant-table-fixed .ant-table-thead > tr > th{
      border-right: none !important;
    }
    /deep/ .ant-table-placeholder{
      border-top: none;
      border-left: none;
      border-right: none;
    }
}

</style>